import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import logo from '../img/logo.png';

/**
 * @param {{ active?: 'tools' | null }} props
 */
export default function AppShellNav({ active = null }) {
  const navigate = useNavigate();
  const { isAuthenticated, logout, user } = useAuthStore();
  const [menuOpen, setMenuOpen] = useState(false);

  const displayName = user?.nombre || user?.username;

  return (
    <header className="apps-header">
      <nav className="apps-wrap apps-nav">
        <Link to="/" className="apps-logo">
          <img className="apps-logo-mark" src={logo} alt="" />
          Devssoft
        </Link>

        <div className="apps-navlinks">
          <Link to="/blog" className="apps-navlink">Blog</Link>
          <Link to="/" className="apps-navlink">
            Inicio
          </Link>
          {active === 'tools' ? (
            <span className="apps-navlink apps-navlink--active" aria-current="page">
              Herramientas
            </span>
          ) : (
            <Link to="/apps" className="apps-navlink">
              Herramientas
            </Link>
          )}
        </div>

        <div className="apps-navcta">
          <button
            type="button"
            className="apps-nav-toggle"
            aria-expanded={menuOpen}
            aria-label="Menú"
            onClick={() => setMenuOpen((v) => !v)}
          >
            Menú
          </button>
          {isAuthenticated ? (
            <div className="apps-user">
              <Link to="/account/google" className="apps-navlink">Cuenta Google</Link>
              <Link to="/account/mcp-access" className="apps-navlink">Acceso MCP</Link>
              <Link to="/account/mcp-guide" className="apps-navlink">Guía MCP</Link>
              {displayName && <span className="apps-user-name">{displayName}</span>}
              <button type="button" className="apps-btn apps-btn-ghost" onClick={logout}>
                Cerrar sesión
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="apps-btn apps-btn-primary"
              onClick={() => navigate('/login')}
            >
              Iniciar sesión
            </button>
          )}
        </div>
      </nav>

      <div className={`apps-mobile-menu${menuOpen ? ' open' : ''}`}>
        <Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link>
        <Link to="/" onClick={() => setMenuOpen(false)}>
          Inicio
        </Link>
        {active === 'tools' ? (
          <span className="apps-navlink--active">Herramientas</span>
        ) : (
          <Link to="/apps" onClick={() => setMenuOpen(false)}>
            Herramientas
          </Link>
        )}
        {isAuthenticated ? (
          <>
            <Link to="/account/google" onClick={() => setMenuOpen(false)}>Cuenta Google</Link>
            <Link to="/account/mcp-access" onClick={() => setMenuOpen(false)}>Acceso MCP</Link>
            <Link to="/account/mcp-guide" onClick={() => setMenuOpen(false)}>Guía MCP</Link>
            {displayName && <span className="apps-mobile-user">{displayName}</span>}
            <button
              type="button"
              className="apps-btn apps-btn-ghost"
              onClick={() => {
                logout();
                setMenuOpen(false);
              }}
            >
              Cerrar sesión
            </button>
          </>
        ) : (
          <button
            type="button"
            className="apps-btn apps-btn-primary"
            onClick={() => {
              navigate('/login');
              setMenuOpen(false);
            }}
          >
            Iniciar sesión
          </button>
        )}
      </div>
    </header>
  );
}
